__turbopack_context__.v({
  "badge": "Badge-module__bHbwFG__badge",
  "exclusive": "Badge-module__bHbwFG__exclusive",
  "founding": "Badge-module__bHbwFG__founding",
  "ltd": "Badge-module__bHbwFG__ltd",
  "sponsored": "Badge-module__bHbwFG__sponsored",
  "verified": "Badge-module__bHbwFG__verified",
});
